module.exports = __webpack_public_path__ + "img/irl.2b77bd80.png";